// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Tabs_TheComp__U5Zt9"};